<template>

  <section class="px-24 mt-16 sm-max:px-8 md-max:mt-10">

    <div class="grid grid-cols-2 gap-10 sm-max:gap-2 md-max:space-y-8">

      <div v-for="(review, index) in reviews" :key="review.reviewerName" class="col-span-1 md-max:col-span-2"
           :class="index===2 || index===3 ? 'lg:pt-12' :''">
        <div class="py-8 space-y-4 rounded-lg px-7 bg-grayReview md-only:p-8 md-max:p-4">
          <nuxt-img
              class="m-auto md-only:my-2"
              loading="lazy"
              alt="review-rating"
              width="148"
              height="23"
              :src="review.reviewImage"
          ></nuxt-img>
          <h3 :class="index===1 ? 'md:pt-4' :''"
              class="font-bold text-center lg:text-3xl md:text-2xl text-17 sm-max:text-17 md-ony:py-4"
              v-html="review.reviewTitle"></h3>
          <div :class="index===1 ? 'md:pt-6' :''"
             class="text-center sm:text-lg text-14 md-max:px-1 sm-max:leading-5 sm:leading-26 lg:h-50 pb-7 md-max:pb-4" v-html="review.reviewText">

          </div>
        </div>

        <div class="flex items-center justify-start mt-4 space-x-4">
          <nuxt-img
              class=""
              width="86"
              height="86"
              loading="lazy"
              alt="review-rating"
              :src="review.reviewerImage"
          ></nuxt-img>
          <div>
            <h5 class="pb-1 text-lg font-bold leading-4 sm:text-22" v-html="review.reviewerName"></h5>
            <h6 class="text-17" v-html="review.reviewerLocation"></h6>
          </div>
        </div>
      </div>

    </div>


  </section>

</template>


<script setup>

const props = defineProps({
  reviews: {
    type: Array,
    default: () => [
      {
        reviewImage: "/assets/images/freebag-rate-5.jpg",
        reviewTitle: "“There Just Is No Better”",
        reviewText: "So smooth, and absolutely no acidity. believe I will have to become a monthly subscriber to bring the cost down even further. When you buy in bulk the price plummets. Do yourselves a favour, come on, you deserve it. Shade grown, hand picked, hand washed, lightly roasted and no pesticides equals this incredible quality.",
        reviewerImage: "/assets/images/freebag-dummy-testimonial-ms.jpg",
        reviewerName: "Sonia P",
        reviewerLocation: "USA"
      },
      {
        reviewImage: "/assets/images/freebag-rate-5.jpg",
        reviewTitle: "“Best Coffee <br class='md-max:hidden'/> " +
            "I’ve Ever Tasted”",
        reviewText: "I’m used to doctoring up my coffee to make it palatable, but with this coffee, I can get away with less sugar/and or creamer. It’s fruity tasting with no bitterness at all. I will definitely be purchasing more!",
        reviewerImage: "/assets/images/freebag-dummy-testimonial-mr.jpg",
        reviewerName: "Ziggy L",
        reviewerLocation: "USA"
      },
      {
        reviewImage: "/assets/images/freebag-rate-5.jpg",
        reviewTitle: "“This Coffee Is Delicious”",
        reviewText: "It is full bodied flavor with a great aroma and the packaging is natural and adorable. It feels great to know that the beans were grown and sustainably harvested from a single source. This makes all the difference! I would definitely purchase this again for my family as well as for gifts for friends. An excellent product!",
        reviewerImage: "/assets/images/freebag-dummy-testimonial-ms.jpg",
        reviewerName: "Chrissy B",
        reviewerLocation: "USA"
      },
      {
        reviewImage: "/assets/images/freebag-rate-5.jpg",
        reviewTitle: "“It Is Smooth, No Bitterness, With Full Bodied Flavor”",
        reviewText: "A bit of cream and this coffee is wonderful. The fact that it is grown on a small farm and the coffee you receive is from just this farm, is what makes this coffee have its wonderful flavor. I am on my second order and am now will be a customer for life.",
        reviewerImage: "/assets/images/freebag-dummy-testimonial-ms.jpg",
        reviewerName: "Nichele G",
        reviewerLocation: "USA"
      },
    ]
  }
})

defineBuilderComponent({
    friendlyName: "Review-2",
    canHaveChildren: true,
    inputs: [
        {
            name: "reviews",
            type: "list",
            defaultValue: [
                {
                    reviewImage: "/assets/images/freebag-rate-5.jpg",
                    reviewTitle: "“There Just Is No Better”",
                    reviewText: "So smooth, and absolutely no acidity. believe I will have to become a monthly subscriber to bring the cost down even further. When you buy in bulk the price plummets. Do yourselves a favour, come on, you deserve it. Shade grown, hand picked, hand washed, lightly roasted and no pesticides equals this incredible quality.",
                    reviewerImage: "/assets/images/freebag-dummy-testimonial-ms.jpg",
                    reviewerName: "Sonia P",
                    reviewerLocation: "USA"
                },
                {
                    reviewImage: "/assets/images/freebag-rate-5.jpg",
                    reviewTitle: "“Best Coffee  I’ve Ever Tasted",
                    reviewText: "I’m used to doctoring up my coffee to make it palatable, but with this coffee, I can get away with less sugar/and or creamer. It’s fruity tasting with no bitterness at all. I will definitely be purchasing more!",
                    reviewerImage: "/assets/images/freebag-dummy-testimonial-mr.jpg",
                    reviewerName: "Ziggy L",
                    reviewerLocation: "USA"
                },
                {
                    reviewImage: "/assets/images/freebag-rate-5.jpg",
                    reviewTitle: "“This Coffee Is Delicious”",
                    reviewText: "It is full bodied flavor with a great aroma and the packaging is natural and adorable. It feels great to know that the beans were grown and sustainably harvested from a single source. This makes all the difference! I would definitely purchase this again for my family as well as for gifts for friends. An excellent product!",
                    reviewerImage: "/assets/images/freebag-dummy-testimonial-ms.jpg",
                    reviewerName: "Chrissy B",
                    reviewerLocation: "USA"
                },
                {
                    reviewImage: "/assets/images/freebag-rate-5.jpg",
                    reviewTitle: "“It Is Smooth, No Bitterness, With Full Bodied Flavor”",
                    reviewText: "A bit of cream and this coffee is wonderful. The fact that it is grown on a small farm and the coffee you receive is from just this farm, is what makes this coffee have its wonderful flavor. I am on my second order and am now will be a customer for life.",
                    reviewerImage: "/assets/images/freebag-dummy-testimonial-ms.jpg",
                    reviewerName: "Nichele G",
                    reviewerLocation: "USA"
                }
            ],
            subFields: [
                {
                    name: "reviewImage",
                    type: "file",
                    allowedFileTypes: [
                        "jpeg",
                        "jpg",
                        "png",
                        "svg"
                    ],
                    defaultValue: "/assets/images/freebag-rate-5.jpg",
                    required: true
                },
                {
                    name: "reviewTitle",
                    type: "richText",
                    defaultValue: "review title"
                },
                {
                    name: "reviewText",
                    type: "richText",
                    defaultValue: "review text"
                },
                {
                    name: "reviewerImage",
                    type: "file",
                    allowedFileTypes: [
                        "jpeg",
                        "jpg",
                        "png",
                        "svg"
                    ],
                    defaultValue: "/assets/images/freebag-dummy-testimonial-ms.jpg",
                    required: true
                },
                {
                    name: "reviewerName",
                    type: "richText",
                    defaultValue: "Reviewer Name"
                },
                {
                    name: "reviewerLocation",
                    type: "richText",
                    defaultValue: "Reviewer Location"
                }
            ]
        }
    ]
});
</script>

